// An Assessment, as drafted for review and as run: for every capability it
// measures, one Roleplay and one Quiz Question.
//
// The Roleplay is tied to the capability's four levels from Capability Setup:
// the situation Elliott presents has to leave room for an answer at any of
// them, so the response can be placed clearly in one. It is taken once: an
// Assessment captures where someone is today; it does not coach.
//
// Elliott writes the draft (POST /v3/admin/capability/assessments/draft; the
// prompt is in BE shared/services/capability/prompts.ts), the manager edits it, and running it saves
// it (POST /v3/admin/capability/assessments). What is here is the shape of the
// draft and the message the employee sees.

import type { LevelCriteria } from '../capabilitySetup';

export interface DraftQuiz {
  question: string;
  options: string[];
  /** Index of the correct option. */
  correct: number;
}

/** One capability's part of the Assessment: its Roleplay and its Quiz Question. */
export interface DraftItem {
  capabilityId: string;
  capabilityName: string;
  roleId: string;
  roleName: string;
  teamName: string;
  /** The capability's levels, as set in Capability Setup: what the Roleplay is graded against. */
  levels: LevelCriteria;
  /** The situation Elliott presents. */
  roleplay: string;
  quiz: DraftQuiz;
}

/** The message the employee sees before they start. */
export const draftMessage = (name: string, ownerName: string | null, itemCount: number): string => {
  const minutes = Math.max(5, itemCount * 4);
  const each = itemCount === 1 ? 'one capability' : `${itemCount} capabilities`;
  return `${ownerName ?? 'Your manager'} has asked you to take ${
    name.trim() || 'this Assessment'
  }. This Assessment covers ${each}, with one Roleplay and one Quiz Question on each, and takes about ${minutes} minutes. Answer each Roleplay as you would in a real conversation. Your results show where you are today, so your Training can focus on what will help you most.`;
};
